import { useRef } from 'react';
import Header from './Header';

function Contact() {
    const form = useRef();

    function submitContact(event) {
        event.preventDefault();

        const mailToEmail = "info@turnaroundrecoveryfoundation.org";
        let body = "Application Form Submitted\n\n";

        // form fields
        let fullname = document.getElementById("fullname").value;
        let phone = document.getElementById("phone").value;
        let email = document.getElementById("email").value;
        let whatdoyouneed = document.getElementById("whatdoyouneed").value;
        let reasonforcontact = document.getElementById("reasonforcontact").value;
        
        // applicant information
        body += `APPLICATION INFORMATION\nFull Name: ${fullname}\nPhone Number: ${phone}\nEmail: ${email}
        \nPhone: ${phone}\nWhat is Needed: ${whatdoyouneed}\nReason for Contact: ${reasonforcontact}\n\n`;
        const subject = `Application Submitted By ${fullname}`;

        // Use encodeURIComponent to handle spaces and special characters
        const mailtoLink = `mailto:${mailToEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        window.location.href = mailtoLink;
    }

    return (
        <div>
            <Header/><br/>
            <div className="container-contact">
                <div style={{textAlign:"center"}} class="eyebrow">Contact Us</div>
                <br/>
                {/* <div class="topbar">Housing Application • The Turn Around Recovery House • Est. 2026</div> */}
                    {/* <div>
                        <br/>
                        <h1>Recovery Housing <span>Application</span></h1>
                        <p>Thank you for your interest in The Turn Around Recovery House. Please complete this application as honestly and thoroughly as possible. Submission does not guarantee acceptance or placement.</p>
                    </div> */}
                    <main>
                    {/* <div class="notice">
                        <h2>Before You Apply</h2>
                        <p>This application helps us determine whether our recovery housing program may be a good fit. Information submitted will be reviewed confidentially by authorized staff. If this is an emergency, please call 911 or contact a crisis support service immediately.</p>
                        <br/>
                    </div> */}
                <div style={{textAlign:"center"}}>
                    <h2 style={{fontWeight:"bold"}}>Get in Touch</h2>
                    <p>Interested in housing, partnerships, donations, or community support? Send us a message.</p>
                    <br/>
                </div>

                <form ref={form} onSubmit={submitContact}>
                    <label>Full Name</label>
                    <input type="text" id="fname" name="fullname" placeholder="Your Name.."/>

                    <label>Email</label>
                    <input type="text" id="email" name="email" placeholder="Your Email.."/>

                    <label>Phone</label>
                    <input type="text" id="phone" name="phone" placeholder="Your Phone Number.."/>

                    <label>Reason for Contact</label>
                    <select id="reasonforcontact" name="reasonforcontact">
                        <option value="Apply for Housing">Apply for Housing</option>
                        <option value="Donate">Donate</option>
                        <option value="Partnership">Partnership</option>
                        <option value="General Question">General Question</option>
                    </select>

                    <label>What Support Do You Need to Become More Stable or Independent?</label>
                    <textarea id="subject" name="whatdoyouneed" style={{height:"200px"}} placeholder="Message.."></textarea>

                    <input type="submit" value="Submit"/>
                </form>
            </main>
            </div>
        </div>
    )
}
export default Contact;